<template>
  <div :class="['pass-dot', switchStr().className]">
    <i class="dot"></i>
    <i>{{ switchStr().label }}</i>
  </div>
</template>

<script>
import i18n from '@/i18n/index.js';
export default {
  props: {
    data: {
      // 具体值
      type: String,
      default: ''
    },
    list: {
      // 类型数据
      type: Array,
      default: () => {
        return [
          {
            value: 'Waiting',
            label: i18n.t('HT.passDot.wait'),
            className: 'waiting'
          },
          {
            value: 'Pass',
            label: i18n.t('HT.options.productStatus3'),
            className: 'pass'
          },
          {
            value: 'No_Pass',
            label: i18n.t('HT.options.productStatus4'),
            className: 'no-pass'
          }
        ];
      }
    }
  },

  methods: {
    /**
     * 判断
     */
    switchStr() {
      let res = {
        label: '',
        className: ''
      };
      for (let i = 0; i < this.list.length; i++) {
        if (this.data == this.list[i]['value']) {
          res = {
            label: this.list[i]['label'],
            className: this.list[i]['className']
          };
          break;
        }
      }
      return res;
    }
  }
};
</script>

<style lang="scss" scoped>
$waiting: #bcc4d5;
$pass: #6799ff;
$no-pass: #f56c6c;

.pass-dot {
  display: flex;
  align-items: center;
  justify-content: center;

  .dot {
    width: 5px;
    height: 5px;
    margin-right: 5px;
    border-radius: 50%;
  }
}
.waiting {
  .dot {
    background-color: $waiting;
  }
}

.no-pass {
  .dot {
    background-color: $no-pass;
  }
}

.pass {
  .dot {
    background-color: $pass;
  }
}
</style>
